module.exports = __webpack_public_path__ + "static/media/cube-3d-yellow.c8fea584.svg";